<template>
  <div class="grid singleGrid" v-if="project">
    <TopHome />

    <div class="single singleText">
      <div class="text wide posright" v-if="project.text">
        <div v-html="project.text"></div>
      </div>
    </div>

    <template v-if="project.images">
      <template v-for="(image, index) in randomList2">
        <div class="single singleImage" :key="index + image.src">
          <div class="singleInner" :class="[randomSize(image, index), setPos(image, index)]">
            <div class="imPad" :style="{paddingBottom: image.ratio + '%'}">
              <img :src="image.src">
            </div>
            <div class="caption">
              <span>{{index + 1 + '&thinsp;/&thinsp;' + project.images.length}}</span>
              <span v-if="image.desc" v-html="'&emsp;' + image.desc"></span>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import TopHome from '@/components/GridTopHome'
import SetProject from '@/components/SetProject'

export default {
  props: ['project'],

  components: {
    TopHome
  },

  mixins: [SetProject],

  computed: {
    randomList2 () {
      let a = null
      if (this.project.images) {
        let myRandomizedList
        myRandomizedList = this.project.images.slice(0)

        a = myRandomizedList
        let i = a.length
        let t
        let j

        while (--i) {
          t = a[i]
          a[i] = a[j = ~~(Math.random() * (i + 1))]
          a[j] = t
        }
      }

      return a
    }
  }
}
</script>
